<template>
  <svg width="607" :height="height" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect fill="none" id="canvas_background" y="-1" x="-1" />
      <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
        <rect fill="url(#gridpattern)" stroke-width="0" y="0" x="0" height="100%" width="100%" />
      </g>
    </g>
    <g>
      <title>Layer 1</title>
      <rect
        stroke="null"
        rx="3"
        id="svg_5"
        :height="height"
        :width="width"
        y="0.278418"
        x="0.082044"
        stroke-width="1.5"
        fill="#666666"
      />
      <rect
        rx="2"
        transform="rotate(-45 480.7962341308593,125.39126586914068) "
        id="svg_8"
        :height="height"
        :width="height"
        y="0.27"
        x="500"
        stroke-width="1.5"
        fill="#666666"
      />
    </g>
  </svg>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { UiTabs } from "../../util";

export default {
  name: "VColorButton",
  props: {
    color: { default: "" },
    width: { default: 32 },
    height: { default: 16 },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
.bg-tag {
  background: rgb(62, 61, 61);
}
.triangle {
  height: 0;
  width: 0;
  margin-left: -1px;
  border-left: 9px solid rgb(62, 61, 61);
  border-right: 9px solid transparent;
  border-bottom: 9px solid transparent;
  border-top: 9px solid transparent;
}
</style>
